// extracted by mini-css-extract-plugin
export default {"modal":"_1CjVZN4-","message":"_1sJtvLSD","button":"_1LBdb-2H"};